import { getIsTouch } from './getIsTouch';

export function getIsMobile(): boolean {
  return getIsTouch() && window.matchMedia('(max-width: 1024px), (max-height: 499px)').matches;
}
